/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Delete_ConfirmInputs */

const cs_templates_delete_confirm = /** @type {(inputs: Templates_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trvale smazat tuto šablonu?`)
};

const en_templates_delete_confirm = /** @type {(inputs: Templates_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this template permanently?`)
};

/**
* | output |
* | --- |
* | "Delete this template permanently?" |
*
* @param {Templates_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_delete_confirm = /** @type {((inputs?: Templates_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_delete_confirm(inputs)
	return cs_templates_delete_confirm(inputs)
});